<template>
  <div class="py-5 my-5">
    <slider
      :current.sync="current"
      :key="current"
      :questions="questions"
      :answers="answers"
      :results="brands"
      @updated="updateAnswer"
      >
    </slider>

  </div>
</template>

<script>
import Question from './Question'
import axios from 'axios'

export default {
  name: 'Survey',
  components: {
    'slider': Question
  },
  data () {
    return {
      brands: [],
      questions: [
        {
          number: 1,
          name: 'welcome',
          title: 'Let’s find your ideal station.',
          description: 'Looking to reach your customers through radio, and don’t know which station is right for you? Use this tool to define your audience, and receive suggestions for which stations could work best for you.',
          type: 'intro',
          updateAnswer: false,
          nextText: 'Find your ideal station'
        },
        {
          number: 2,
          name: 'target',
          title: 'Who are your ideal customers?',
          description: 'Select the average age range of your ideal customer.',
          type: 'multi',
          updateAnswer: true,
          nextText: 'Next Step',
          answers: [
            {
              name: '18-34 Years',
              value: '25'
            },
            {
              name: '35-44 Years',
              value: '35'
            },
            {
              name: '45-54 Years',
              value: '45'
            },
            {
              name: '55+ Years',
              value: '55'
            }
          ]
        },
        {
          number: 3,
          name: 'gender',
          title: 'Who are your ideal customers?',
          description: 'Drag the orange slider to show whether your customers tend to be more male or female.',
          type: 'slider',
          updateAnswer: true,
          nextText: 'Find your ideal station',
          range: {
            min: 0,
            max: 91
          }
        },
        {
          number: 4,
          name: 'result',
          title: 'Great! These stations could work for you.',
          description: 'Based on your ideal customer profile we think these stations could work for you. Get in touch with us for targeted advice and to learn how you can best use radio to reach your target audience.',
          type: 'results',
          updateAnswer: false,
          nextText: 'Get in touch'
        }
      ]
    }
  },
  computed: {
    current () {
      if (this.$route.params.step) {
        return Number(this.$route.params.step)
      } else {
        return 1
      }
    },
    answers () {
      return JSON.parse(sessionStorage.getItem('answers'))
    }
  },
    // Fetches posts when the component is created.
  created () {
    if (sessionStorage.getItem('answers') === null) {
      var answer = {
        gender: 46,
        target: 25
      }
      sessionStorage.setItem('answers', JSON.stringify(answer))
    }
    axios.get('//www.trb.co.nz/brands.json')
    .then(response => {
      this.brands = []
      this.brands.push(response.data.data)
    })
    .catch(e => {
      console.log(e)
    })

  },
  methods: {
    updateAnswer (value) {
      var answers = JSON.parse(sessionStorage.getItem('answers'))
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          answers[key] = value[key]
        }
      }
      sessionStorage.setItem('answers', JSON.stringify(answers))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/survey/Survey.vue